import { render, staticRenderFns } from "./MapOt_Pohr.vue?vue&type=template&id=2aa8b9ee&"
import script from "./MapOt_Pohr.vue?vue&type=script&lang=js&"
export * from "./MapOt_Pohr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports